import { LinearProgress, Box, Typography, Button, Paper } from '@mui/material';
import { ArrowRight, Save } from 'lucide-react';

export default function ProgressHeader({ percentage, missingCount, onGoToMissing, lastSaved }) {
  return (
    <Paper 
      elevation={0} 
      sx={{ 
        p: 2, 
        mb: 3, 
        borderRadius: 3, 
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
        <Box>
          <Typography variant="subtitle2" sx={{ fontWeight: 600, color: 'text.primary' }}>
            Completamento richiesta
          </Typography>
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            {missingCount > 0
              ? `Mancano ancora ${missingCount} ${missingCount === 1 ? 'dato' : 'dati'}`
              : 'Tutti i dati sono stati inseriti!'
            }
          </Typography>
        </Box>
        <Typography variant="h5" sx={{ fontWeight: 700, color: 'primary.main' }}>
          {percentage}%
        </Typography>
      </Box>
      
      <LinearProgress 
        variant="determinate" 
        value={percentage} 
        sx={{ 
          height: 8, 
          borderRadius: 4, 
          mb: 2,
          bgcolor: 'grey.100',
          '& .MuiLinearProgress-bar': {
            borderRadius: 4,
          }
        }} 
      />

      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        {missingCount > 0 && (
          <Button 
            variant="text" 
            size="small" 
            onClick={onGoToMissing} 
            startIcon={<ArrowRight size={14} />}
            sx={{ 
              fontSize: '0.75rem', 
              textTransform: 'none',
              p: 0,
              minWidth: 'auto',
              '&:hover': { bgcolor: 'transparent', textDecoration: 'underline' }
            }}
          >
            Vai al prossimo campo
          </Button>
        )}
        {lastSaved && (
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 0.5, 
            ml: 'auto',
            color: 'text.secondary',
            fontSize: '10px'
          }}>
            <Save size={12} />
            <Typography variant="caption" sx={{ fontSize: '10px' }}>
              Salvato {lastSaved}
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
}